var render = function render() {
  var _vm$arr$;
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.title,
      visible: _vm.dialogVisible,
      footer: null,
      width: 500
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("div", {
    staticClass: "page"
  }, [_c("div", {
    staticClass: "cont",
    style: {
      background: `url(${(_vm$arr$ = _vm.arr[0]) === null || _vm$arr$ === void 0 ? void 0 : _vm$arr$.style.backgroundImage}) no-repeat`,
      "background-size": "cover"
    }
  }, _vm._l(_vm.arr, function (item, index) {
    return _c("mobile-preview", {
      key: index + 1,
      attrs: {
        itemObj: item,
        itemIndex: index,
        arrNum: _vm.arr.length - 1,
        themeColor: _vm.themeColor,
        isConfigure: false,
        pageType: _vm.pageType,
        pageDescription: _vm.pageDescription,
        pageDescriptionConfig: _vm.pageDescriptionConfig
      },
      on: {
        premiumClick: function ($event) {
          _vm.premiumShow = true;
        },
        buttonModalClick: _vm.onOpenButtonModal
      }
    });
  }), 1), _vm.premiumShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "2"
    },
    on: {
      click: function ($event) {
        _vm.premiumShow = false;
      }
    }
  }), _c("premium-model", {
    attrs: {
      styleObj: _vm.configureObj.style,
      themeColor: _vm.themeColor
    },
    on: {
      premiumClick: _vm.onClickPremium
    }
  })], 1) : _vm._e(), _vm.pageModalShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "2"
    },
    on: {
      click: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  }), _c("page-modal", {
    attrs: {
      pagePopUpConfig: _vm.pagePopUpConfig
    },
    on: {
      popupClick: function ($event) {
        _vm.pageModalShow = false;
      }
    }
  })], 1) : _vm._e(), _vm.buttonModalShow ? _c("div", [_c("div", {
    staticStyle: {
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.5)",
      position: "absolute",
      left: "0",
      top: "0",
      "z-index": "2"
    },
    on: {
      click: function ($event) {
        _vm.buttonModalShow = false;
      }
    }
  }), _c("button-modal", {
    attrs: {
      buttonPopUpConfig: _vm.buttonPopUpConfig
    },
    on: {
      popupClick: function ($event) {
        _vm.buttonModalShow = false;
      }
    }
  })], 1) : _vm._e()])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };